import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpAdv6 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-6143">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-6144"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-6145">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-6146">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-6147">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-6148">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-6149">
          <div className="text-left" data-id="element-6150">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-6151">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-6152">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-6153">
        <div className="max-w-4xl mx-auto" data-id="element-6154">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-6155">
            SPECIAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-6156">
            Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1
            Users... Maybe Even You
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-6157">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-6158">
              <img src="https://cdn.magicpatterns.com/uploads/5VxcxuZ348arn9hf8oRkeE/6OUBdNn4rvjDcxkk8ToP9_(1).jpg" alt="Dr. Robin Hogan" className="w-full h-full object-cover" data-id="element-6159" />
            </div>
            <div className="flex-1" data-id="element-6160">
              <div className="flex items-center gap-2 mb-2" data-id="element-6161">
                <span className="text-base font-medium text-gray-900" data-id="element-6162">
                  Written By Robin Hogan, RN, MSN
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-6163" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-6164">
                Verified Metabolic Health Specialist
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-6165">
                <div className="flex items-center gap-1" data-id="element-6166">
                  <ClockIcon className="h-4 w-4" data-id="element-6167" />
                  <span data-id="element-6168">4 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-6169">
                  <EyeIcon className="h-4 w-4" data-id="element-6170" />
                  <span data-id="element-6171">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-6172">
            
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-6173">
            The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And
            The Breakthrough Protocol That's Bringing Back Joy Without Stopping
            The Weight Loss
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-6174">
            <div className="mb-1 flex items-center" data-id="element-6175">
              <span className="font-medium mr-2" data-id="element-6176">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-6177">
              <span className="font-medium mr-2" data-id="element-6178">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv6;